import { useState, useEffect, useRef } from 'react';
import CreateSidebar from './CreateSidebar/CreateSidebar';
import EditSidebar from './EditSidebar/EditSidebar';
import { useImage } from '../../context/ImageContext';
import sparklIcon from '../../assets/icons/sparkle.png';

const Sidebar = ({
  editUploadedImages,
  setEditUploadedImages,
  brushSize,
  setBrushSize,
  eraserSize,
  setEraserSize,
  activeButton,
  setActiveButton,
  selectedProduct,
  setSelectedProduct,
  fetchAllCreateHistory,
  fetchAllEditHistory,
  setAllCreateHistory,
  setAllEditHistory,
  allCreateHistory,
  allEditHistory,
  setCreditsAvailable,
  setSelectedEditGroup,
  setCreatePageNumber,
  setEditPageNumber,
  createNumberOfImages,
  editNumberOfImages,
  setCreateNumberOfImages,
  setEditNumberOfImages,
  createLoadingCircle,
  editLoadingCircle,
  setCreateLoadingCircle,
  setEditLoadingCircle,
  openSection,
  setOpenSection,
}) => {
  const [createEstTime, setCreateEstTime] = useState(0);
  const [jobResponseCreate, setJobResponseCreate] = useState({});
  const [progressCreate, setProgressCreate] = useState(createEstTime);
  const [productPrompt, setProductPrompt] = useState("");
  const [refImagePrompt, setRefImagePrompt] = useState("");
  const [CreativeControlValue, setCreativeControlValue] = useState(1);
  const [selectedStyle, setSelectedStyle] = useState({ "src": "https://img.icons8.com/?size=100&id=6RfZ-eZQz0ee&format=png&color=737373", "name": "Select Style", alt: "Select Style" });
  const [createPrompt, setCreatePrompt] = useState("");  // Product in a modern living room with neutral tones, wooden flooring, and soft natural light coming through large windows. Everything is clean, cozy, and magazine-ready  
  const createContainerRef = useRef(null);
  const createImageRef = useRef(null);
  const [createRefNum, setCreateRefNum] = useState(5);
  const [createRandomize, setCreateRandomize] = useState(true);
  const [maxstyle, setMaxstyle] = useState(false);
  const [createAdjustDropdownIsOpen, setCreateAdjustDropdownIsOpen] = useState(true);
  const [createControlOptions, setCreateControlOptions] = useState([
    { value: 0, label: "Enhanced", description: "Works best for simpler and big products - more artistic" },
    { value: 1, label: "Mode 2", description: "Closely adheres to the prompt - preserves product better (recommended)" }
  ]);
  const [isRephrasing, setIsRephrasing] = useState(false);
  const [isRephraseClicked, setIsRephraseClicked] = useState(false);
  const [advancedSettingsOpen, setAdvancedSettingsOpen] = useState(false);
  const [backdropOnly, setBackdropOnly] = useState(false);
  const [aspectRatio, setAspectRatio] = useState({ value: 1, label: '1:1', desc: 'Square' });
  const [reLight, setReLight] = useState(false);
  const [selectedReferenceImage, setSelectedReferenceImage] = useState({
    "src": "https://img.icons8.com/?size=100&id=6RfZ-eZQz0ee&format=png&color=737373",
    "name": "Select Reference Image"
  });

  // Edit refs  
  const [loadingCircle, setLoadingCircle] = useState(false);
  const [editEstTime, setEditEstTime] = useState(0);
  const [jobResponseEdit, setJobResponseEdit] = useState({});
  const [progressEdit, setProgressEdit] = useState(editEstTime);
  const [editProductPrompt, setEditProductPrompt] = useState("");
  const [editIsRephrasing, setEditIsRephrasing] = useState(false);
  const [editIsRephraseClicked, setEditIsRephraseClicked] = useState(false);
  const [color, setColor] = useState("#5850EC");
  const [colorRefImage, setColorRefImage] = useState(null);
  const [reColorPrompt, setReColorPrompt] = useState("");
  const [uploadedProductImage, setUploadedProductImage] = useState(null);
  const [editSelectedProduct, setEditSelectedProduct] = useState({ "src": "https://img.icons8.com/?size=100&id=6RfZ-eZQz0ee&format=png&color=737373", "name": "No Product Selected", alt: "No Product Selected" });
  const [inputValue, setInputValue] = useState(20);
  const [selectedAction, setSelectedAction] = useState('add');
  const [accessoryImage, setAccessoryImage] = useState(null);
  const [editPrompt, setEditPrompt] = useState('');
  const [editRefNum, setEditRefNum] = useState(5);
  const [editCreateControlOptions, setEditCreateControlOptions] = useState([
    { value: 0, label: "API 1", description: "Works best for text-based edits - Mask and prompt. " },
    { value: 1, label: "API 2", description: "Use for replacing or adding specific objects or products - Mask and select image" }
  ]);

  const { activeTab, setActiveTab } = useImage();
  const [hoveredTab, setHoveredTab] = useState(null);
  const [hoveredTabRect, setHoveredTabRect] = useState(null);
  const [sidebarRect, setSidebarRect] = useState(null);
  const headerHoverText = {
    create: "Create new scenes, perspectives, and angles while the product's remains unchanged.",
    edit: "Refine generated image or upload your own. Remove, Replace or Add assets with precision.  ",
  };

  // Create Loading Bar...............
  const intervalRef = useRef(null);
  useEffect(() => {
    setProgressCreate(createEstTime);
  }, [createEstTime]);

  useEffect(() => {
    if (progressCreate > 0) {
      intervalRef.current = setInterval(() => {
        setProgressCreate((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(intervalRef.current);
            return 0;
          }
          // else if (check_job_status(jobResponseCreate) === 0) {
          //   // if (Object.keys(jobResponseCreate).length !== 0) 
          //   return 0;
          // }

          return prevTime - 1;
        });
      }, 1000);
    } else {
      clearInterval(intervalRef.current);
      // console.log("Fetching create history......");
      setAllCreateHistory([]);
      setCreatePageNumber(0);
      fetchAllCreateHistory(allCreateHistory, setAllCreateHistory, 0, 'all_createPage')

      setCreateEstTime(0);
    }
    return () => clearInterval(intervalRef.current); // Cleanup on unmount or dependency change
  }, [progressCreate]);

  // Edit Loading Bar...............
  const intervalRef2 = useRef(null);
  useEffect(() => {
    setProgressEdit(editEstTime);
  }, [editEstTime]);

  useEffect(() => {
    if (progressEdit > 0) {
      intervalRef2.current = setInterval(() => {
        setProgressEdit((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(intervalRef.current);
            return 0;
          }
          // else if (check_job_status(jobResponseEdit) === 0) {
          //   // if (Object.keys(jobResponseEdit).length !== 0) 
          //   return 0;
          // }

          return prevTime - 1;
        });
      }, 1000);
    } else {
      clearInterval(intervalRef.current);
      // console.log("Fetching edit history......");
      setAllEditHistory([]);
      setEditPageNumber(0);
      fetchAllEditHistory(allEditHistory, setAllEditHistory, 0)
      setEditEstTime(0);
    }
    return () => clearInterval(intervalRef2.current); // Cleanup on unmount or dependency change
  }, [progressEdit]);


  // Helper to get tab element and set rect
  const handleTabMouseEnter = (tab, e) => {
    setHoveredTab(tab);
    if (e && e.currentTarget) {
      const rect = e.currentTarget.getBoundingClientRect();
      setHoveredTabRect(rect);
      // Get sidebar rect
      const sidebar = document.querySelector('aside');
      if (sidebar) {
        setSidebarRect(sidebar.getBoundingClientRect());
      }
    }
  };
  const handleTabMouseLeave = () => {
    setHoveredTab(null);
    setHoveredTabRect(null);
  };

  return (
    <aside className="w-full lg:w-1/4 min-h-screen mt-16 bg-white border-r border-gray-200 relative" >
      <div className="fixed w-full lg:w-1/4 bg-white z-10 border-b border-gray-200 shadow-sm">
        <div className="flex w-full">
          {/* Create Tab */}
          <div
            className={`flex items-center justify-center cursor-pointer w-1/2 py-3 transition-all duration-150 ${activeTab === 'create'
              ? 'text-purple-600 border-b-2 border-purple-600 mx-6'
              : 'text-gray-500 hover:text-purple-500 hover:border-b-2 hover:border-purple-200 mx-6'
              }`}
            onClick={() => setActiveTab('create')}
            onMouseEnter={e => handleTabMouseEnter('create', e)}
            onMouseLeave={handleTabMouseLeave}
            style={{ position: 'relative' }}
          >
            <div className="flex items-center space-x-2">
              <img src={sparklIcon} alt="Create" className="w-5 h-5 lg:w-6 lg:h-6" />
              <span className="font-medium text-sm lg:text-base">Create</span>
            </div>
          </div>

          {/* Edit Tab */}
          <div
            className={`flex items-center justify-center cursor-pointer w-1/2 py-3 transition-all duration-150 ${activeTab === 'edit'
              ? 'text-purple-600 border-b-2 border-purple-600 mx-6'
              : 'text-gray-500 hover:text-purple-500 hover:border-b-2 hover:border-purple-200 mx-6'
              }`}
            onClick={() => setActiveTab('edit')}
            onMouseEnter={e => handleTabMouseEnter('edit', e)}
            onMouseLeave={handleTabMouseLeave}
            style={{ position: 'relative' }}
          >
            <div className="flex items-center space-x-2">
              <i className="fas fa-edit text-lg lg:text-xl"></i>
              <span className="font-medium text-sm lg:text-base">Edit</span>
            </div>
          </div>
        </div>
        {/* Tooltip rendered outside the tab containers to avoid clipping */}
        {hoveredTab && hoveredTabRect && sidebarRect && (
          (() => {
            // Calculate tooltip width and padding
            const tooltipWidth = 280; // Fixed width for the tooltip
            const tooltipPadding = 16; // Padding on each side

            // Calculate the center point of the tab
            const tabCenter = hoveredTabRect.left + (hoveredTabRect.width / 2);

            // Calculate the maximum allowed left position
            const maxLeft = window.innerWidth - tooltipWidth - tooltipPadding;

            // Calculate the initial left position
            let left = tabCenter - (tooltipWidth / 2);

            // Adjust position if tooltip would go off screen
            if (left < tooltipPadding) {
              left = tooltipPadding;
            } else if (left > maxLeft) {
              left = maxLeft;
            }

            return (
              <div
                className="fixed z-[99] pointer-events-none animate-fadein"
                style={{
                  left: left,
                  top: hoveredTabRect.bottom - sidebarRect.top + sidebarRect.top + 8, // 8px below the tab
                  width: tooltipWidth,
                }}
              >
                <div
                  className="flex items-start gap-2 px-3 py-3 text-sm rounded-lg border-2 shadow-md bg-white"
                  style={{
                    borderColor: '#8B5CF6', // Purple border matching InfoTooltip
                    color: '#374151', // Text color matching InfoTooltip
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)', // Shadow matching InfoTooltip
                    fontSize: '0.650rem', // Font size matching InfoTooltip
                    lineHeight: '1.4', // Line height matching InfoTooltip
                    whiteSpace: 'normal', // Allow text to wrap
                    borderRadius: '8px', // Border radius matching InfoTooltip
                    padding: '6px', // Padding matching InfoTooltip
                  }}
                >
                  <span>{headerHoverText[hoveredTab]}</span>

                  {/* Arrow pointing up to the tab */}
                  <div
                    style={{
                      position: 'absolute',
                      width: 0,
                      height: 0,
                      border: '6px solid transparent',
                      top: '-12px',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      borderBottomColor: '#8B5CF6'
                    }}
                  />
                </div>
              </div>
            );
          })()
        )}
      </div>

      {activeTab === 'create' ? (
        <div className="mt-16 p-4 lg:p-6 pb-24">
          <CreateSidebar
            selectedProduct={selectedProduct}
            setSelectedProduct={setSelectedProduct}
            createEstTime={createEstTime}
            setCreateEstTime={setCreateEstTime}
            setJobResponseCreate={setJobResponseCreate}
            progressCreate={progressCreate}
            setCreditsAvailable={setCreditsAvailable}
            value={CreativeControlValue}
            setValue={setCreativeControlValue}
            selectedStyle={selectedStyle}
            setSelectedStyle={setSelectedStyle}
            prompt={createPrompt}
            setPrompt={setCreatePrompt}
            productPrompt={productPrompt}
            setProductPrompt={setProductPrompt}
            refImagePrompt={refImagePrompt}
            setRefImagePrompt={setRefImagePrompt}
            loadingCircle={createLoadingCircle}
            setLoadingCircle={setCreateLoadingCircle}
            containerRef={createContainerRef}
            imageRef={createImageRef}
            refNum={createRefNum}
            randomize={createRandomize}
            numberOfImages={createNumberOfImages}
            setRefNum={setCreateRefNum}
            setRandomize={setCreateRandomize}
            setNumberOfImages={setCreateNumberOfImages}
            maxstyle={maxstyle}
            setMaxstyle={setMaxstyle}
            adjustDropdownIsOpen={createAdjustDropdownIsOpen}
            setAdjustDropdownIsOpen={setCreateAdjustDropdownIsOpen}
            options={createControlOptions}
            isRephrasing={isRephrasing}
            setIsRephrasing={setIsRephrasing}
            isRephraseClicked={isRephraseClicked}
            setIsRephraseClicked={setIsRephraseClicked}
            advancedSettingsOpen={advancedSettingsOpen}
            setAdvancedSettingsOpen={setAdvancedSettingsOpen}
            backdropOnly={backdropOnly}
            setBackdropOnly={setBackdropOnly}
            aspectRatio={aspectRatio}
            setAspectRatio={setAspectRatio}
            reLight={reLight}
            setReLight={setReLight}
            selectedReferenceImage={selectedReferenceImage}
            setSelectedReferenceImage={setSelectedReferenceImage}
          />
        </div>
      ) : (
        <EditSidebar
          editUploadedImages={editUploadedImages}
          setEditUploadedImages={setEditUploadedImages}
          brushSize={brushSize}
          setBrushSize={setBrushSize}
          eraserSize={eraserSize}
          setEraserSize={setEraserSize}
          activeButton={activeButton}
          setActiveButton={setActiveButton}
          editEstTime={editEstTime}
          setEditEstTime={setEditEstTime}
          setJobResponseEdit={setJobResponseEdit}
          progressEdit={progressEdit}
          setCreditsAvailable={setCreditsAvailable}
          setSelectedEditGroup={setSelectedEditGroup}
          selectedAction={selectedAction}
          setSelectedAction={setSelectedAction}
          selectedProduct={editSelectedProduct}
          setSelectedProduct={setEditSelectedProduct}
          inputValue={inputValue}
          setInputValue={setInputValue}
          accessoryImage={accessoryImage}
          setAccessoryImage={setAccessoryImage}
          prompt={editPrompt}
          setPrompt={setEditPrompt}
          loadingCircle={loadingCircle}
          setLoadingCircle={setLoadingCircle}
          editLoadingCircle={editLoadingCircle}
          setEditLoadingCircle={setEditLoadingCircle}
          refNum={editRefNum}
          setRefNum={setEditRefNum}
          numberOfImages={editNumberOfImages}
          setNumberOfImages={setEditNumberOfImages}
          options={editCreateControlOptions}
          productPrompt={editProductPrompt}
          setProductPrompt={setEditProductPrompt}
          isRephrasing={editIsRephrasing}
          setIsRephrasing={setEditIsRephrasing}
          isRephraseClicked={editIsRephraseClicked}
          setIsRephraseClicked={setEditIsRephraseClicked}
          color={color}
          setColor={setColor}
          colorRefImage={colorRefImage}
          setColorRefImage={setColorRefImage}
          reColorPrompt={reColorPrompt}
          setReColorPrompt={setReColorPrompt}
          uploadedProductImage={uploadedProductImage}
          setUploadedProductImage={setUploadedProductImage}
          openSection={openSection}
          setOpenSection={setOpenSection}
        />
      )}


    </aside>
  );
};

export default Sidebar;